import globaltypes from '../globaltypes'
import types from './types'
export default {
  [types.actions.clearSession]: context => {
    context.dispatch(globaltypes.planning.actions.clearSession)
    context.commit(globaltypes.shoppingcart.mutations.deleteAll)
    context.commit(globaltypes.ui.mutations.setDataLoaded, { tab: 'calendar', val: false })
    context.commit(globaltypes.ui.mutations.setDataLoaded, { tab: 'crops', val: false })
    context.commit(globaltypes.ui.mutations.setDataLoaded, { tab: 'planning', val: false })
  },
  [types.actions.fill]: async context => {
    await context.dispatch(globaltypes.planning.actions.load)
    context.dispatch(globaltypes.shoppingcart.actions.fill)
  },
  [types.actions.setInformation]: (context, info) => {
    context.commit(types.mutations.setInformation, info)
    if (context.getters[types.getters.informationTimeoutChecker] != null) context.commit(types.mutations.setInformationTimeoutChecker, null)
    context.commit(types.mutations.setInformationTimeoutChecker, setTimeout(() => {
      context.commit(types.mutations.setInformation, null)
    }, 7000))
  }
}
